import { t } from '@lingui/macro'

import { ListRow } from '@/modules/shared/components/list-row/ListRow'
import { formatListDate } from '@/modules/shared/helpers/locale'

import type { DocumentMessageActivity } from '../../types/documents.types'

// The line under the title names the kind of document.
function getDescription(document: DocumentMessageActivity) {
  switch (document.meta?.messageType) {
    case 'Document': {
      return t({
        id: 'document.document',
        message: 'Document',
      })
    }

    case 'Brochure': {
      return t({
        id: 'document.brochure',
        message: 'Brochure',
      })
    }

    default: {
      return ''
    }
  }
}

type DocumentItemProps = {
  document: DocumentMessageActivity
}

export const DocumentItem = ({ document }: DocumentItemProps) => (
  <ListRow>
    <ListRow.Badge>
      {/* A brochure reads as print, a document as a file */}
      <ListRow.Icon icon={['fal', document.meta?.messageType === 'Brochure' ? 'newspaper' : 'file']} />
    </ListRow.Badge>
    <ListRow.Title>{document.meta?.attachments?.[0]?.name ?? document.display}</ListRow.Title>
    {document.status === 'scheduled' ? <ListRow.UnreadDot /> : null}
    <ListRow.Description>{getDescription(document)}</ListRow.Description>
    <ListRow.Meta>{document.plannedAt ? formatListDate(document.plannedAt) : ''}</ListRow.Meta>
  </ListRow>
)
